import React from 'react';
import { Chip } from '@vectord/components';
import classNames from 'classnames';

import styles from './HybridChip.module.scss';

function HybridChip({ className }) {
  return <Chip className={classNames(styles.root, className)}>Hybrid</Chip>;
}

export default HybridChip;
